import * as XLSX from 'xlsx';

/**
 * Exporta un dataset a Excel reutilizando la misma forma de columnas
 * (titleText/dataIndex/render) usada por components/Table.jsx.
 * @param {object[]} dataSource
 * @param {object[]} columns
 * @param {string} fileName sin extensión
 */
const exportarExcelDesdeColumnas = (dataSource, columns, fileName) => {
  const worksheet = XLSX.utils
    .json_to_sheet(dataSource.map((record) => columns.reduce((obj, column) => {
      const { render } = column;
      const valor = render !== undefined
        ? render(record[column.dataIndex], record)
        : record[column.dataIndex];
      return { ...obj, [column.titleText]: valor };
    }, {})));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default exportarExcelDesdeColumnas;
